export const portsViewMode = {
  groups: {
    right: {
      position: 'right',
      attrs: {
        circle: {
          r: 0,
          magnet: false,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    left: {
      position: 'left',
      attrs: {
        circle: {
          r: 0,
          magnet: false,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    top: {
      position: 'top',
      attrs: {
        circle: {
          r: 0,
          magnet: false,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    bottom: {
      position: 'bottom',
      attrs: {
        circle: {
          r: 0,
          magnet: false,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    }
  },
  items: [
    {
      id: 'port-right',
      group: 'right'
    },
    {
      id: 'port-left',
      group: 'left'
    },
    {
      id: 'port-top',
      group: 'top'
    },
    {
      id: 'port-bottom',
      group: 'bottom'
    }
  ]
}

export const portsEditMode = {
  groups: {
    right: {
      position: 'right',
      attrs: {
        circle: {
          r: 6,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    left: {
      position: 'left',
      attrs: {
        circle: {
          r: 6,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    top: {
      position: 'top',
      attrs: {
        circle: {
          r: 6,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    },
    bottom: {
      position: 'bottom',
      attrs: {
        circle: {
          r: 6,
          magnet: true,
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: '#fff',
          style: {
            visibility: 'visible'
          }
        }
      },
      maxConnections: -1
    }
  },
  items: [
    {
      id: 'port-right',
      group: 'right'
    },
    {
      id: 'port-left',
      group: 'left'
    },
    {
      id: 'port-top',
      group: 'top'
    },
    {
      id: 'port-bottom',
      group: 'bottom'
    }
  ]
}

export const getNodeRectdefaultProp = ({ approvedIcon, durationIcon, PlannedDateIcon, ActualDateIcon, ports, editMode }) => {
  if (editMode) {
    return {
      inherit: 'rect',
      width: 90,
      height: 60,
      zIndex: 2,
      // movable: true,
      attrs: {
        body: {
          stroke: '#5F95FF',
          strokeWidth: 1,
          fill: 'rgba(95,149,255,0.2)',
          refWidth: 1,
          refHeight: 1,
          rx: '5',
          ry: '5'
        },
        image: {
          'xlink:href': approvedIcon,
          width: 16,
          height: 16,
          x: 12,
          y: 12
        },
        durationIcon: {
          'xlink:href': durationIcon,
          width: 16,
          height: 16,
          x: 12,
          y: 35
        },
        duration: {
          text: '0',
          refX: 40,
          refY: 44,
          fill: '#6b6a6a',
          fontSize: 12,
          'text-anchor': 'start'
        },
        text: {
          text: 'Heading',
          refX: 40,
          refY: 21,
          fill: 'rgba(0,0,0)',
          fontSize: 14,
          'text-anchor': 'start'
        },
        flagBox: {
          width: 0, // 40
          height: 0, // 15
          stroke: 'rgb(27, 142, 27',
          fill: 'rgb(27, 142, 27,.1)',
          strokeWidth: 0.5,
          x: 100,
          y: 12,
          rx: 5,
          ry: 5,
          class: 'flagBox-start-box'
        },
        flagText: {
          text: '',
          // fill: 'rgb(27, 142, 27',
          fontSize: 10,
          fontWeight: 'bold',
          zIndex: 2
        }
        // tooltip: {
        //   text: ''
        // }
      // title: {
      //   text: 'content',
      //   refX: 40,
      //   refY: 38,
      //   fontSize: 12,
      //   fill: 'rgba(0,0,0,0.6)',
      //   'text-anchor': 'start'
      // }
      },
      markup: [
        {
          tagName: 'rect',
          selector: 'body'
        },
        {
          tagName: 'image',
          selector: 'image'
        },
        {
          tagName: 'image',
          selector: 'durationIcon'
        },
        {
          tagName: 'text',
          selector: 'duration'
        },
        {
          tagName: 'text',
          selector: 'title'
        },
        {
          tagName: 'text',
          selector: 'flagText'
        },
        {
          tagName: 'rect',
          selector: 'flagBox'
        },
        { tagName: 'title', selector: 'tooltip' }
      ],
      // nodeMovable: true,
      ports: { ...ports }
    }
  }
  return {
    inherit: 'rect',
    width: 140,
    height: 80,
    zIndex: 2,
    // movable: true,
    attrs: {
      body: {
        stroke: '#5F95FF',
        strokeWidth: 1,
        fill: 'rgba(95,149,255,0.2)',
        refWidth: 1,
        refHeight: 1,
        rx: '5',
        ry: '5'
      },
      image: {
        'xlink:href': approvedIcon,
        width: 16,
        height: 16,
        x: 8,
        y: 12
      },
      durationIcon: {
        'xlink:href': durationIcon,
        width: 14,
        height: 14,
        x: 8,
        y: 31
      },
      plannedDateIcon: {
        'xlink:href': PlannedDateIcon,
        width: 14,
        height: 14,
        x: 8,
        y: 49
      },
      actualDateIcon: {
        'xlink:href': ActualDateIcon,
        width: 14,
        height: 14,
        x: 8,
        y: 65
      },
      duration: {
        text: '0',
        refX: 30,
        refY: 33,
        fill: '#6b6a6a',
        fontSize: 10,
        'text-anchor': 'start'
      },
      text: {
        text: 'Heading',
        refX: 30,
        refY: 20,
        fill: 'rgba(0,0,0)',
        fontSize: 12,
        fontWeight: 'bold',
        'text-anchor': 'start'
      },
      blink: {
        r: 0,
        fill: 'green',
        strokeWidth: 1,
        x: -10,
        y: -10,
        class: 'blink'
      },
      flagBox: {
        width: 0, // 40
        height: 0, // 15
        stroke: 'rgb(27, 142, 27',
        fill: 'rgb(27, 142, 27,.1)',
        strokeWidth: 0.5,
        x: 100,
        y: 12,
        rx: 5,
        ry: 5,
        class: 'flagBox-start-box'
      },
      flagText: {
        // text: 'Start',
        fill: 'rgb(27, 142, 27)',
        fontSize: 10,
        fontWeight: 'bold',
        zIndex: 2
      },
      PlanendDateText: {
        text: '-- - --',
        refX: 30,
        refY: 50,
        fill: '#6b6a6a',
        fontSize: 10
      },
      ActualDateText: {
        text: '-- - --',
        refX: 30,
        refY: 68,
        fill: '#6b6a6a',
        fontSize: 10
      }
      // title: {
      //   text: 'content',
      //   refX: 40,
      //   refY: 38,
      //   fontSize: 12,
      //   fill: 'rgba(0,0,0,0.6)',
      //   'text-anchor': 'start'
      // }
    },
    tooltip: {
      text: 'Title'
    },
    markup: [
      {
        tagName: 'rect',
        selector: 'body'
      },
      {
        tagName: 'image',
        selector: 'image'
      },
      {
        tagName: 'image',
        selector: 'plannedDateIcon'
      },
      {
        tagName: 'image',
        selector: 'actualDateIcon'
      },
      {
        tagName: 'text',
        selector: 'title'
      },
      {
        tagName: 'text',
        selector: 'text'
      },
      {
        tagName: 'text',
        selector: 'PlanendDateText'
      },
      {
        tagName: 'text',
        selector: 'ActualDateText'
      },
      {
        tagName: 'text',
        selector: 'flagText'
      },
      {
        tagName: 'rect',
        selector: 'flagBox'
      },
      {
        tagName: 'image',
        selector: 'durationIcon'
      },

      {
        tagName: 'text',
        selector: 'duration'
      },
      {
        tagName: 'circle',
        selector: 'blink'
      },
      { tagName: 'title', selector: 'tooltip' }
    ]
  }
}
export const getDefaultPhaseRectProp = () => {
  return {
    inherit: 'rect',
    width: 140,
    height: 60,
    zIndex: 1,
    markup: [
      { tagName: 'rect', selector: 'body' },
      { tagName: 'rect', selector: 'name-box' },
      { tagName: 'text', selector: 'text' },
      { tagName: 'title', selector: 'tooltip' }
    ],
    attrs: {
      body: {
        strokeWidth: 1,
        fill: 'rgba(245, 240, 108,.3)',
        stroke: '#ffe7ba'
      },
      'name-box': {
        width: 140,
        height: 20,
        fill: 'transparent',
        stroke: '#096dd9',
        strokeWidth: 1,
        x: 0,
        y: 0
      },
      text: {
        // text: 'phase',
        fill: 'black',
        fontSize: 12,
        fontWeight: 'bold',
        refY: 10,
        textAnchor: 'middle',
        zIndex: 2
      }
      // tooltip: {
      //   text: 'Phase'
      // }
    }
  }
}

export const qcNodeDefaultProp = ({ approvedIcon, durationIcon, QC }) => {
  return {
    // }
    attrs: {
      body: {
        fill: QC.FILL,
        stroke: QC.STROKE,
        strokeWidth: 1,
        refWidth: 1,
        refHeight: 1,
        rx: '5',
        ry: '5'
      },
      image: {
        'xlink:href': approvedIcon,
        width: 16,
        height: 16,
        x: 12,
        y: 12
      },
      durationIcon: {
        'xlink:href': durationIcon,
        width: 16,
        height: 16,
        x: 12,
        y: 35
      },
      duration: {
        text: '0',
        refX: 40,
        refY: 44,
        fill: '#6b6a6a',
        fontSize: 12,
        'text-anchor': 'start'
      },
      text: {
        text: 'QC',
        refX: 40,
        refY: 21,
        fill: 'rgba(0,0,0)',
        fontSize: 14,
        'text-anchor': 'start'
      },
      flagBox: {
        width: 0, // 40
        height: 0, // 15
        stroke: 'rgb(27, 142, 27',
        fill: 'rgb(27, 142, 27,.1)',
        strokeWidth: 0.5,
        x: 100,
        y: 12,
        rx: 5,
        ry: 5,
        class: 'flagBox-start-box'
      },
      flagText: {
        text: '',
        // fill: 'rgb(27, 142, 27',
        fontSize: 10,
        fontWeight: 'bold',
        zIndex: 2
      }
      // tooltip: {
      //   text: 'QC'
      // }
      // title: {
      //   text: 'content',
      //   refX: 40,
      //   refY: 38,
      //   fontSize: 12,
      //   fill: 'rgba(0,0,0,0.6)',
      //   'text-anchor': 'start'
      // }
    },
    markup: [
      {
        tagName: 'rect',
        selector: 'body'
      },
      {
        tagName: 'image',
        selector: 'image'
      },
      {
        tagName: 'image',
        selector: 'durationIcon'
      },
      {
        tagName: 'text',
        selector: 'duration'
      },
      {
        tagName: 'text',
        selector: 'title'
      },
      {
        tagName: 'text',
        selector: 'flagText'
      },
      {
        tagName: 'rect',
        selector: 'flagBox'
      },
      { tagName: 'title', selector: 'tooltip' }
    ],
    // nodeMovable: true,
    ports: {
      ...portsEditMode,
      items: [
        {
          id: 'port-right',
          group: 'right'
        },
        {
          id: 'port-left',
          group: 'left'
        },
        {
          id: 'port-top',
          group: 'top'
        },
        {
          id: 'port-bottom',
          group: 'bottom'
        }
      ]
    }
  }
}
export const startEndStepValidation = (wfMap) => {
  let hasSatrtStep = false
  let hasEndStep = false
  for (const item in wfMap) {
    if (wfMap[item].source.size === 0) { hasEndStep = true }
    if (wfMap[item].target.size === 0) { hasSatrtStep = true }
    if (hasEndStep && hasSatrtStep) {
      return { hasEndStep, hasSatrtStep }
    }
  }
  return { hasEndStep, hasSatrtStep }
}
